// Single source of truth for the TACH API base URL.
//
// Shared by the authenticated client (AxiosWrapper) and the token-less public
// client (publicApi) so both resolve the host identically:
//   - local dev (NODE_ENV=development): a same-origin relative path that the
//     CRA dev server proxies to the real API (see src/setupProxy.js). Direct
//     browser calls from https://localhost to the deployed API are blocked by
//     its CORS / API-Gateway origin checks (403).
//   - staging build (REACT_APP_ENV=staging): the staging host.
//   - everything else (prod build): the prod host.
export const getApiBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return '/api/v1';
  }
  if (process.env.REACT_APP_ENV === 'staging') {
    return 'https://api-staging.tachmoney.com/api/v1';
  }
  return 'https://api-prod.tachusa.com/api/v1';
};
